<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4><router-link to="/config/security">{{ $t('Security') }}</router-link> / {{ $t('Two-step verification') }}</h4>
        </div>
      </div>
    </div>
    
    <div class="vflex-row-1 p-3 pb-3">
      <router-view></router-view>
    </div>
  </div>

</template>

<script>
export default {
  name: 'ProfileTwofa',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Profile/ProfileTwofa.vue